// src/data/exchangeConfig.js
// Hardcoded exchange → company list mapping.
// Companies are listed by display name; ticker_service resolves symbols.

const EXCHANGE_CONFIG = {
  NASDAQ: {
    label: 'NASDAQ',
    code: 'US',           // EODHD exchange code
    currency: 'USD',
    country: 'United States',
    companies: [
      'Adobe',
      'Advanced Micro Devices',
      'Airbnb',
      'Alnylam Pharmaceuticals',
      'Alphabet Inc.',
      'Amazon',
      'American Electric Power',
      'Amgen',
      'Analog Devices',
      'Apple',
      'Applied Materials',
      'AppLovin',
      'Arm Holdings',
      'ASML Holding',
      'Autodesk',
      'Automatic Data Processing',
      'Axon Enterprise',
      'Baker Hughes',
      'Booking Holdings',
      'Broadcom',
      'Cadence Design Systems',
      'Charter Communications',
      'Cintas',
      'Cisco',
      'Cognizant',
      'Comcast',
      'Constellation Energy',
      'Copart',
      'Costco',
      'CrowdStrike',
      'CSX Corporation',
      'Datadog',
      'DexCom',
      'Diamondback Energy',
      'DoorDash',
      'Electronic Arts',
      'Exelon',
      'Fastenal',
      'Fortinet',
      'GE HealthCare',
      'Gilead Sciences',
      'Honeywell',
      'IDEXX Laboratories',
      'Intel Corporation',
      'Intuit',
      'Intuitive Surgical',
      'Keurig Dr Pepper',
      'KLA Corporation',
      'Kraft Heinz',
      'Lam Research',
      'Linde',
      'Lumentum',
      'Marriott International',
      'Marvell Technology',
      'Mercado Libre',
      'Meta Platforms, Inc.',
      'Microchip Technology',
      'Micron Technology',
      'Microsoft Corporation',
      'MicroStrategy',
      'Mondelez International',
      'Monolithic Power Systems',
      'Monster Beverage',
      'Netflix, Inc.',
      'NVIDIA Corporation',
      'NXP Semiconductors',
      'O\'Reilly Automotive',
      'Old Dominion Freight Line',
      'PACCAR',
      'Palantir Technologies',
      'Palo Alto Networks',
      'Paychex',
      'PayPal',
      'PDD Holdings',
      'PepsiCo',
      'QUALCOMM',
      'Regeneron Pharmaceuticals',
      'Roper Technologies',
      'Ross Stores',
      'Seagate Technology',
      'Shopify',
      'Starbucks',
      'Synopsys',
      'T-Mobile US',
      'Take-Two Interactive',
      'Tesla, Inc.',
      'Texas Instruments',
      'Verisk Analytics',
      'Vertex Pharmaceuticals',
      'Walmart',
      'Warner Bros. Discovery',
      'Workday',
      'Xcel Energy',
      'Zscaler',
    ],
  },

  NYSE: {
    label: 'NYSE',
    code: 'US',           // EODHD treats NYSE under 'US' too
    currency: 'USD',
    country: 'United States',
    companies: [
      '3M',
      'Abbott Laboratories',
      'AbbVie',
      'Accenture',
      'Air Products and Chemicals',
      'Altria Group',
      'American Express',
      'American Tower',
      'AstraZeneca',
      'AT&T',
      'Bank of America',
      'Becton Dickinson',
      'Berkshire Hathaway',
      'BlackRock',
      'Boeing',
      'Boston Scientific',
      'Bristol-Myers Squibb',
      'Caterpillar',
      'Charles Schwab',
      'Chevron',
      'Chubb',
      'Cigna Group',
      'Citigroup',
      'Coca-Cola',
      'Colgate-Palmolive',
      'ConocoPhillips',
      'Crown Castle',
      'CVS Health',
      'Danaher',
      'Deere & Company',
      'Dell Technologies',
      'Duke Energy',
      'Eaton Corporation',
      'Ecolab',
      'Elevance Health',
      'Eli Lilly',
      'Emerson Electric',
      'ExxonMobil',
      'FedEx',
      'Fiserv',
      'GE Aerospace',
      'General Dynamics',
      'Goldman Sachs',
      'HCA Healthcare',
      'Home Depot',
      'IBM',
      'Illinois Tool Works',
      'Intercontinental Exchange',
      'Johnson & Johnson',
      'JPMorgan Chase',
      'Lockheed Martin',
      'Lowe\'s Companies',
      'Marsh & McLennan',
      'Mastercard',
      'McDonald\'s',
      'Medtronic',
      'Merck',
      'MetLife',
      'Moody\'s Corporation',
      'Morgan Stanley',
      'Motorola Solutions',
      'NextEra Energy',
      'Nike',
      'Norfolk Southern',
      'Northrop Grumman',
      'Oracle',
      'Parker Hannifin',
      'Pfizer',
      'Philip Morris International',
      'Procter & Gamble',
      'Progressive Corporation',
      'Prologis',
      'Realty Income',
      'Republic Services',
      'RTX Corporation',
      'S&P Global',
      'Salesforce',
      'ServiceNow',
      'Sherwin-Williams',
      'Simon Property Group',
      'Southern Company',
      'Spotify',
      'Stryker',
      'Target',
      'Thermo Fisher Scientific',
      'Trane Technologies',
      'Travelers Companies',
      'Uber Technologies',
      'Union Pacific',
      'UnitedHealth Group',
      'UPS',
      'Verizon',
      'Visa',
      'Walt Disney',
      'Waste Management',
      'Welltower',
      'Wells Fargo',
      'Williams Companies',
      'Zoetis',
    ],
  },

  FTSE: {
    label: 'FTSE 100',
    code: 'LSE',          // EODHD exchange code for London
    currency: 'GBP',
    country: 'United Kingdom',
    companies: [
      '3i Group',
      'Admiral Group',
      'Anglo American',
      'Antofagasta',
      'Associated British Foods',
      'AstraZeneca',
      'Auto Trader Group',
      'Aviva',
      'BAE Systems',
      'Barclays',
      'Barratt Redrow',
      'Beazley',
      'BP',
      'British American Tobacco',
      'British Land',
      'BT Group',
      'Bunzl',
      'Burberry Group',
      'Centrica',
      'Compass Group',
      'ConvaTec',
      'Croda International',
      'DCC plc',
      'Diageo',
      'Diploma',
      'Endeavour Mining',
      'Entain',
      'Experian',
      'Fresnillo',
      'Games Workshop',
      'Glencore',
      'GSK',
      'Haleon',
      'Halma',
      'Hiscox',
      'Howdens Joinery',
      'HSBC',
      'ICG',
      'IG Group',
      'IHG Hotels & Resorts',
      'IMI',
      'Imperial Brands',
      'Informa',
      'International Airlines Group',
      'Intertek',
      'JD Sports Fashion',
      'Kingfisher',
      'Land Securities',
      'Legal & General',
      'Lloyds Banking Group',
      'London Stock Exchange Group',
      'M&G',
      'Marks & Spencer',
      'Melrose Industries',
      'National Grid',
      'NatWest Group',
      'Next',
      'Pearson',
      'Pershing Square Holdings',
      'Persimmon',
      'Prudential',
      'Reckitt',
      'RELX',
      'Rentokil Initial',
      'Rio Tinto',
      'Rolls-Royce Holdings',
      'Sage Group',
      'Sainsbury\'s',
      'Schroders',
      'Scottish Mortgage Investment Trust',
      'SEGRO',
      'Severn Trent',
      'Shell',
      'Smiths Group',
      'Smith & Nephew',
      'Spirax Group',
      'SSE',
      'Standard Chartered',
      'St. James\'s Place',
      'Tesco',
      'Unilever',
      'United Utilities',
      'Vodafone Group',
      'Weir Group',
      'Whitbread',
    ],
  },
};

/**
 * Return array of exchange keys.
 */
export function getExchangeKeys() {
  return Object.keys(EXCHANGE_CONFIG);
}

/**
 * Return exchange metadata (label, code, currency, country).
 */
export function getExchangeMeta(exchangeKey) {
  return EXCHANGE_CONFIG[exchangeKey] || null;
}

/**
 * Return company list for a given exchange key.
 */
export function getCompaniesForExchange(exchangeKey) {
  return EXCHANGE_CONFIG[exchangeKey]?.companies || [];
}

/**
 * Return all companies across all exchanges (flat, unique).
 */
export function getAllCompanies() {
  const all = new Set();
  for (const ex of Object.values(EXCHANGE_CONFIG)) {
    ex.companies.forEach((c) => all.add(c));
  }
  return [...all].sort();
}

export default EXCHANGE_CONFIG;
